import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CustomMatIconModule } from '@mydocma/component-library/src/lib/custom-mat-icon';
import { CalibrationIconComponent } from './calibration-icon/calibration-icon.component';
import { DropableComponent } from './dropable/dropable.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    CustomMatIconModule
  ],
  declarations: [
    CalibrationIconComponent,
    DropableComponent
  ],
  exports: [
    CalibrationIconComponent,
    DropableComponent
  ]
})
export class CalibrationCommonModule { }
